import React from 'react'
import { BaseView } from '@/components/base'
import { useTheme } from '@/hooks/useTheme'

interface ToggleProps {
  isActive: boolean
  onToggle: (isActive: boolean) => void
}

export const Toggle: React.FC<ToggleProps> = ({ isActive, onToggle }) => {
  const theme = useTheme()

  // Точные размеры из React Native версии
  const switchWidth = 50
  const switchHeight = 30
  const circleSize = 24
  const padding = 2

  const handleClick = () => {
    onToggle(!isActive)
  }

  return (
    <BaseView
      style={{
        width: `${switchWidth}px`,
        height: `${switchHeight}px`,
        borderRadius: `${switchHeight}px`,
        backgroundColor: isActive
          ? theme.colors.background.secondaryBlue // secondaryBlue как в RN
          : theme.colors.background.buttonPrimaryDisabled, // buttonPrimaryDisabled
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        position: 'relative',
        padding: `${padding}px`,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
      }}
      onClick={handleClick}
    >
      <BaseView
        circle
        circleSize={circleSize}
        style={{
          backgroundColor: theme.colors.background.tertiaryWhite, // tertiaryWhite как в RN
          transition: 'transform 0.3s ease',
          transform: isActive
            ? `translateX(${switchWidth - circleSize - padding * 2}px)`
            : 'translateX(0px)',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
          position: 'absolute',
          left: `${padding}px`,
        }}
      />
    </BaseView>
  )
}
